import axios, { type AxiosError } from 'axios'

export const apiClient = axios.create({
  baseURL: '/api/v1',
  headers: { 'Content-Type': 'application/json' },
})

// Attach access token from memory store on every request.
apiClient.interceptors.request.use((config) => {
  const token = getAccessToken()
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

// On 401, attempt silent refresh then retry once.
apiClient.interceptors.response.use(
  (res) => res,
  async (error: AxiosError) => {
    const original = error.config as typeof error.config & { _retry?: boolean }
    if (error.response?.status === 401 && !original._retry) {
      original._retry = true
      try {
        const { data } = await axios.post<{ access_token: string }>('/api/v1/auth/refresh', {}, {
          withCredentials: true,
        })
        setAccessToken(data.access_token)
        original.headers!.Authorization = `Bearer ${data.access_token}`
        return apiClient(original)
      } catch {
        setAccessToken(null)
        window.location.href = '/login'
      }
    }
    return Promise.reject(error)
  }
)

// In-memory token store (never written to localStorage).
let _token: string | null = null
export const getAccessToken = () => _token
export const setAccessToken = (t: string | null) => { _token = t }

// Restore auth state from refresh token cookie on app load
export async function restoreAuthState() {
  if (_token) return // Already have a token

  try {
    const { data } = await axios.post<{ access_token: string }>('/api/v1/auth/refresh', {}, {
      withCredentials: true,
    })
    setAccessToken(data.access_token)
  } catch {
    // No valid refresh token, user needs to log in
  }
}
